import { render, staticRenderFns } from "./input-footer-menu.vue?vue&type=template&id=461a69ee&"
import script from "./input-footer-menu.vue?vue&type=script&lang=js&"
export * from "./input-footer-menu.vue?vue&type=script&lang=js&"
import style0 from "./input-footer-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports